import React from 'react';

import styled from 'styled-components';

import ClickableCellValue from './ClickableCellValue';

const SmallText = styled.span`
  font-size: 12px;
  color: var(--text-secondary);
`;

const Text = styled.div`
  font-size: 14px;
`;

const Subtitle = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

type Props = {
  newCompetitorIncentivesCount: number;
  onClick: () => void;
};

const IncentivesCell = ({ newCompetitorIncentivesCount, onClick }: Props) => {
  if (newCompetitorIncentivesCount === 0) {
    return <SmallText>-</SmallText>;
  }

  return (
    <ClickableCellValue onClick={onClick} dataTestId="my-communities-incentives-cell" withChevron>
      <Text>{newCompetitorIncentivesCount} New</Text>
      <Subtitle>recently</Subtitle>
    </ClickableCellValue>
  );
};

export default IncentivesCell;
